import script from "./Agenda.vue?vue&type=script&setup=true&lang=js"
export * from "./Agenda.vue?vue&type=script&setup=true&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=2198a7c7&lang=scss&scoped=true"
script.__scopeId = "data-v-2198a7c7"

export default script